import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form','frontImage','backImage','add1Image','add2Image'];
  static classes = ['hide'];
  static values = {uploadurl: String, removeimageurl: String};

  autoUpload(event){
    const el = event.currentTarget;
    const params = event.params;
    const targetName = params.targetname;
    if(el.value != null && el.value != ""){
      const formData = new FormData(this.formTarget);
      formData.append("type",targetName);
      Rails.ajax({
        url: this.uploadurlValue,
        type: "POST",
        dataType: 'json',
        data: formData,
        success: (response) => {
          const viewDiv = document.getElementById("image_view_"+targetName);
          const image = viewDiv.querySelector("img");
          image.src = response.image_url;
          viewDiv.classList.remove(this.hideClass);
          document.getElementById("image_upload_"+targetName).classList.add(this.hideClass);
          document.getElementById("insurance_card_id").value = response.ic_id;
          document.getElementById("insurance_card_"+targetName+"_error_message").textContent = "";
        }
      });
    }
  }

  removeImage(event){
    const params = event.params;
    const targetName = params.targetname;
    const formData = new FormData(this.formTarget);
    formData.append("type",targetName);
    Rails.ajax({
      url: this.removeimageurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        console.log(response);
        const viewDiv = document.getElementById("image_view_"+targetName);
        const image = viewDiv.querySelector("img");
        image.src = "";
        viewDiv.classList.add(this.hideClass);
        document.getElementById("image_upload_"+targetName).classList.remove(this.hideClass);
      }
    });
  }

}
